/* eslint-disable */
import StorePlugin from '../plugin/StorePlugin';

class AppFactory {
  constructor(config, Vue) {
    this.__Vue = Vue;
    this.__config = config;
  }

  load(options) {
    // const vue = new Vue(Object.assign({
    //   // store: Vue.globalStore,
    //   // store: Vue.$store || StorePlugin.store,
    // }, this.__config, options));
    const vue = new this.__Vue(this.__config);
    return vue;
  }

  static registerVueModule(routePrefix) {
    const module = registerModule.modules.find(item => item.routePrefix === routePrefix);
    module.registeredVueApp = true;
  }

  static mount(app) {
    if (app && app.$options && app.$options.name) {
      app.$mount(`#${app.$options.name}-container`);
    }
  }

  static get store() {
    return StorePlugin.store;
  }
}

export default AppFactory;



// WEBPACK FOOTER //
// ./src/factory/AppFactory.js